import { compose } from 'lodash/fp';
import type AdminLink from '../../../../../types/AdminLink';
import api from '../../../../api';
import PageHeader from '../../../components/PageHeader';
import PageTitle from '../../../components/PageTitle';
import { withAppContext, type AppContext } from '../../../hoc/withAppContext';
import { withPageData } from '../../../hoc/withPageData';
import AdminOverview from './presenter';
import { countAdminErrors, groupLinksByCategory } from './service';

export type AdminOverviewPageProps = {
    adminLinks: AdminLink[];
    promotionLinks: AdminLink[];
    appContext: AppContext;
};

function AdminOverviewPage({ adminLinks, promotionLinks, appContext }: AdminOverviewPageProps) {
    const title = 'Settings';
    return (
        <div className="newLayout-contentWidthXS">
            <PageTitle title={title} />
            <PageHeader title={title} />
            <AdminOverview
                categories={groupLinksByCategory([...adminLinks, ...promotionLinks])}
                errorCount={countAdminErrors(adminLinks)}
                currentUser={appContext.user}
            />
        </div>
    );
}

export default compose(
    withPageData({
        resolve: {
            adminLinks: () => api.admin.getSettingsLinks(),
            promotionLinks: () => api.admin.getPromotionsLinks(),
        },
    }),
    withAppContext
)(AdminOverviewPage);
